import SeoLandingPage from "@/components/SeoLandingPage";
import heroImage from "@/assets/bathroom-demolition.jpg";

const BathroomDemolition = () => (
  <SeoLandingPage
    slug="bathroom-demolition-wisconsin"
    metaTitle="Bathroom Demolition Services | Green Bay & De Pere, WI"
    metaDescription="Bathroom demolition in Northeast Wisconsin. Tub, shower, vanity, tile, flooring, and drywall removal with careful site protection and complete debris hauling."
    h1="Bathroom Demolition in Northeast Wisconsin"
    heroImage={heroImage}
    heroIntro="We strip bathrooms back to the agreed starting point for your remodel while protecting hallways, stairs, and nearby finished rooms."
    serviceName="Bathroom Demolition"
    bullets={[
      "Vanity, countertop, mirror, cabinet, and fixture removal.",
      "Tub, shower surround, tile, mortar bed, and enclosure removal.",
      "Flooring, underlayment, drywall, plaster, and insulation tear-out.",
      "Controlled work-area protection and debris containment.",
      "Hauling for dense tile, cast materials, and general demolition debris.",
      "Broom-clean room ready for inspection and the next trade.",
    ]}
    whyUs={[
      "Experience with heavy tile assemblies and tight bathroom access routes.",
      "Careful selective demolition around plumbing locations and materials that remain.",
      "Straightforward estimates that identify the exact tear-out stopping point.",
      "Local crews serving homeowners and remodelers across Northeast Wisconsin.",
    ]}
    processSteps={[
      { title: "Document the bathroom", detail: "Upload wide photos plus close-ups of tile, tub or shower, vanity, and access areas." },
      { title: "Define the stopping point", detail: "We confirm whether removal ends at studs, subfloor, backer board, or another renovation-ready condition." },
      { title: "Protect and remove", detail: "After required utility disconnects, we contain the route and complete the approved selective demolition." },
      { title: "Haul and hand off", detail: "Debris leaves with us and the bathroom is swept for your plumber, electrician, or remodeler." },
    ]}
    faqs={[
      { q: "How much does bathroom demolition cost?", a: "Cost varies with tile thickness, mortar beds, cast-iron fixtures, access, room size, and the depth of removal. Photos help us prepare an accurate project-specific estimate." },
      { q: "How long does bathroom demolition take?", a: "A straightforward bathroom tear-out is often completed in one working day. Heavy tile, plaster, difficult access, or multiple layers can extend the schedule." },
      { q: "Will you remove the bathtub or shower?", a: "Yes, when included in the scope. Water must be shut off and plumbing safely disconnected before removal begins." },
      { q: "Can you remove bathroom tile without damaging nearby rooms?", a: "We use floor and doorway protection, controlled removal methods, and a planned debris route to reduce impact on adjoining finished areas." },
      { q: "What happens if hidden water damage is found?", a: "We stop, document the condition, and discuss it with you before expanding the scope. Remediation or structural repair is not assumed without approval." },
    ]}
    ctaHeadline="Ready to open up your bathroom remodel?"
  />
);

export default BathroomDemolition;
